<template>
  <div class="duplicates-table">
    <!-- TODO: need to check when duplicates exist -->
    <div v-if="totalDuplicates === 0">
      <strong>There are currently no duplicates detected within the system.</strong>
    </div>
    <div v-else>
      <spinner :show="isLoading" />
      <div v-if="!isLoading">
        <div v-if="allowPagination" class="pagination">
          <b-pagination
            v-if="totalDuplicates > perPage"
            v-model="currentPage"
            :total-rows="totalDuplicates"
            :per-page="perPage"
            aria-controls="org-table"
          ></b-pagination>
        </div>
        <b-table
          id="org-table"
          :items="duplicates"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:cell(isDuplicate)="data">
            <div class="table-duplicate--inner"></div>
          </template>
          <template v-slot:cell(firstName)="data">
            <!-- eslint-disable-next-line -->
            <span v-html="data.value"></span>
          </template>
          <template v-slot:cell(lastName)="data">
            <!-- eslint-disable-next-line -->
            <span v-html="data.value"></span>
          </template>
          <template v-slot:cell(address)="data">
            <!-- eslint-disable-next-line -->
            <span v-html="data.value"></span>
          </template>
          <template v-slot:cell(info)="data">
            <a href="#" @click="onInfoClick(data.item, $event)"><i class="zmdi zmdi-alert-circle"></i></a>
          </template>
          <template v-slot:cell(organization)="data">
            <a :href="`TODO:${data.item.id}`" class="underline">
              {{ data.item.organization }}
            </a>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import eventNames from '../../util/eventNames';
import Spinner from '../Spinner';
import modalNames from '../../util/modalNames';

export default {
  name: 'DuplicatesTable',
  components: { Spinner, },
  props: {
    limit: {
      type: Number,
      default: 10
    },
    allowPagination: {
      type: Boolean,
      default: true
    },
    sortListBy: {
      type: String,
      default: 'entries'
    },
    isSortDesc: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      sortBy: this.sortListBy,
      sortDesc: this.isSortDesc,
      perPage: this.limit,
      currentPage: 1,
      fields: [
        {
          key: 'isDuplicate',
          sortable: false,
          class: 'table-duplicate'
        },
        {
          key: 'firstName',
          sortable: true
        },
        {
          key: 'lastName',
          sortable: true
        },
        {
          key: 'address',
          sortable: false
        },
        {
          key: 'info',
          sortable: false,
          class: 'table-alert-icon'
        }
      ],
    }
  },
  computed: {
    duplicates() {
      if (!this.$store.getters.getDuplicates) return [];
      return this.$store.getters.getDuplicates
        .filter(item => item.duplicates && item.duplicates.length > 1)
        .map(item => {
          if (item) {
            if (item.duplicates.length > 1) {
              return {
                // TODO: This is not the way to do this, there is probably a vNode creation method
                //    or a dangerouslySetInnerHTML (React) way to do this.
                firstName: `${item.duplicates[0].recipientFirstName} <br /> ${item.duplicates[1].recipientFirstName}`,
                lastName: `${item.duplicates[0].recipientLastName} <br /> ${item.duplicates[1].recipientLastName}`,
                address: `${item.duplicates[0].recipientAddressLine1} <br /> ${item.duplicates[1].recipientAddressLine1}`,
                duplicates: item,
              }
            }
          }
          //item did not exist
          return {};
      });
    },
    isLoading() {
      return this.$store.getters.getIsDuplicateLoading;
    },
    totalDuplicates() {
      let duplicateLength = this.duplicates.length;
      // HACK: this should be from Vuex, the computed duplicates() above should actually live in Vuex
      this.$emit(eventNames.DUPLICATECOUNT, duplicateLength);
      return duplicateLength;
    }
  },
  mounted() {
    this.$store.dispatch('listDuplicates');
  },
  methods: {
   onInfoClick(item, event) {
      event.preventDefault();
      console.log('Duplicate Table Item: ', item);
      const payload = {
        main: item.id,
        duplicates: [item.duplicates.id],
      };
      this.$store.dispatch('setDuplicateToResolve', payload)
      this.$bvModal.show(modalNames.ORGANIZATION_DUPLICATE_MODAL);
      //this.$bvModal.show(modalNames.DUPLICATE_MODAL);
     }
  }
}
</script>

<style lang="scss">
.duplicates-table {
  .table-alert-icon {
    padding-top: 22px;
    padding-right: 22px;
  }
}
</style>
